export const routes = [{
    path: '/reset',
    name: 'reset',
    component: () => import('@/views/reset')
  },
  {
    path: '*',
    redirect: '/login',
    hidden: true
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')

  }
]